export default "__VITE_ASSET__D3O6aP6W__"